import React from "react";
import { useRouteError, Link } from "react-router-dom";
import { Col, Row, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import DpmLogo from "../Images/glowDPM.png"
import { FaFacebook } from "react-icons/fa";
import { FaPhoneVolume } from "react-icons/fa6";
import { CgWebsite } from "react-icons/cg";
import { SiMinutemailer } from "react-icons/si";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

export const Maintenance = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/");
    };

    const copyEmail = async () => {
        await navigator.clipboard.writeText("apply@dpm.navajo-nsn.gov");
    };

    return (
        <>
            <Row
                onClick={() => handleClick()}
                className="shadow-sm nav-bg-color m-0 p-0 nav-font"
                style={{
                    minWidth: "100vw",
                    display: "flex",
                    alignItems: "center",
                }}
                id="maintenance-page"
            >
                <Col xs={3} lg={5} className="d-flex justify-content-end">
                    <img src={DpmLogo} width="90" height="auto" alt="Logo" />
                </Col>
                <Col xs={9} lg={7} className="d-flex justify-content-start">
                    <span className=" text-white navbar-title py-4">
                        Department of Personnel Management
                    </span>
                </Col>
            </Row>

            <header className="container-fluid bg-warning pt-2 ">
                <Row>
                    <h5 className="text-center align-middle text-dark">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-megaphone" viewBox="0 0 16 16">
                            <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 75 75 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0m-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233q.27.015.537.036c2.568.189 5.093.744 7.463 1.993zm-9 6.215v-4.13a95 95 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A61 61 0 0 1 4 10.065m-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68 68 0 0 0-1.722-.082z" />
                        </svg>&nbsp;&nbsp;
                        Scheduled maintenance: 9/8/2026 Apply portal will be unavailable from 2:00pm to 2:15pm (MDT) for maintenance.
                    </h5>
                </Row>
            </header>

            <Row
                className="m-0 p-0"
                id="detail"
                style={{
                    minHeight: "78.5vh",
                    minWidth: "100vw",
                    display: "flex",
                }}>
                <Container className="">
                    <Row className="bg-body-secondary rounded-3 d-flex justify-content-center m-5 p-5">
                        <FontAwesomeIcon
                            icon={faExclamationTriangle}
                            size={"5x"}
                            style={{
                                color: "orange",
                                textShadow: "0 0 2px #000",
                            }} />
                        <h1 className="text-center">
                            Scheduled Maintenance in progress.
                        </h1>
                        <Row>
                            <h4 className="text-center">
                                {"We're"} currently working on the website. Thank you for your patience!
                            </h4>
                        </Row>
                    </Row>
                </Container>
            </Row>

            <Row
                xs={12}
                className="m-0 p-0 shadow-sm nav-bg-color footer-font"
                style={{
                    position: "relative",
                    minHeight: "4vh",
                    display: "flex",
                    alignItems: "center",
                    minWidth: "100vw",
                }}
            >
                <Row className="d-flex fluid justify-content-center m-0 p-0">
                    <Col sm={4} className="d-flex fluid justify-content-center">
                        <div>
                            <h5 className="mt-1 p-0 d-flex fluid justify-content-center">
                                Contact Information:
                            </h5>
                            <hr className="mt-2 mb-2"></hr>
                            <a
                                className="footer-link d-flex fluid justify-content-center"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                href="tel://9283576697"
                            >
                                <FaPhoneVolume /> &nbsp;(928) 357-6697
                            </a>
                            <a className="footer-link" onClick={copyEmail}>
                                <SiMinutemailer /> DPM.ITSupport@dpm.navajo-nsn.gov
                            </a>
                        </div>
                    </Col>
                    <Col sm={4} className="d-flex fluid justify-content-center">
                        <div>
                            <h5 className="mt-1 p-0 d-flex fluid justify-content-center">
                                Resources:
                            </h5>
                            <hr className="mt-2 mb-2"></hr>
                            <a
                                className="footer-link d-flex fluid justify-content-center"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                target="_blank"
                                rel="noopen noreferrer"
                                href="https://www.dpm.navajo-nsn.gov"
                            >
                                <CgWebsite /> &nbsp;dpm.navajo-nsn.gov
                            </a>
                        </div>
                    </Col>
                    <Col sm={4} className="d-flex fluid justify-content-center">
                        <div>
                            <h5 className="mt-1 p-0 d-flex fluid justify-content-center">
                                Follow us here:
                            </h5>
                            <hr className="mt-2 mb-2"></hr>
                            <a
                                className="footer-link d-flex fluid justify-content-center fs-5"
                                target="_blank"
                                rel="noopen noreferrer"
                                href="https://facebook.com/nn.apply"
                            >
                                <FaFacebook />
                            </a>
                        </div>
                    </Col>
                </Row>
                <Row className="d-flex fluid justify-content-center  m-0 p-0">
                    © Copyright 2026 NAVAJO NATION DPM All Rights Reserved
                </Row>
                <Row className="d-flex justify-content-center m-0 p-0">
                    <div className="center-div">
                        <Link to="/terms-of-use" className="links">
                            Terms of Use
                        </Link>{" "}
                        |
                        <Link to="/privacy-policy" className="links">
                            Privacy Policy
                        </Link>{" "}
                        |
                        <Link to="/disclaimer" className="links">
                            Disclaimer
                        </Link>
                    </div>
                </Row>
            </Row>
        </>
    );
};